exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fil0 {\n\tfill: black;\n\tfill-rule: nonzero;\n}\n", ""]);

// exports
